import "./audit.styl";
import { sidebarCollapseController } from "../_resources/ui-library.js";
import { getSubtab, setSubtab, backfillSubtab } from "../_resources/url-state.js";
import AskAccessView from "./AskAccessView.js";
import LobbyView from "./LobbyView.js";
import ByUsersView from "./ByUsersView.js";
import ByResourceView from "./ByResourceView.js";

const SELECTED_SUBPANEL = 'admin.audit.selected_subpanel_id';

export default function Audit({dom, message, getToken}){
  const container = d3.select(dom).select(".contentSection");
  
  sidebarCollapseController(dom);
  const subpanels = ['ask', 'lobby', "byusers", "byresource"];
  const navItems = d3.select(dom).select(".admin-sidebar").selectAll(".nav-item");

  const askAccessView = new AskAccessView({ dom: container, message });
  const lobbyView = new LobbyView({ dom: container, message });
  const byUsersView = new ByUsersView({ dom: container, message });
  const byResourceView = new ByResourceView({ dom: container, message });

  function render(page, refresh = false) {
    navItems.on('click', function(event){
        const target = d3.select(this).attr("data-route");
        event.preventDefault();
        renderSubpanelContent(target, page);
      });

    const subpanelId = getSubtab(SELECTED_SUBPANEL, subpanels);
    renderSubpanelContent(subpanelId, page);
    backfillSubtab(subpanelId);
  }

  function renderSubpanelContent(subpanelId) {
    setSubtab(subpanelId, SELECTED_SUBPANEL);

    container.html('');
    container.class(`contentSection audit-${subpanelId}-view`);

    navItems.classed('active', function(){
      const target = d3.select(this).attr("data-route");
      return target === subpanelId
    });

    if (subpanelId === 'ask') {
      askAccessView.render();
    } else
    if (subpanelId === 'lobby') {
      lobbyView.render();
    } else 
    if (subpanelId === 'byusers') {
      byUsersView.render();
    } else
    if (subpanelId === 'byresource') {
      byResourceView.render();
    } else {
      container.append('p')
        .text(`Missing subpanel: ${subpanelId}.`);
    }
  }



  return {render};
}


